import { useLang } from "@/i18n";
import { IMG } from "@/data/media";
import { PageHero } from "@/components/PageHero";
import { FadeUp } from "@/components/motion";
import { SupportCta } from "@/components/SupportCta";
import { BackLink, Objectives, ProjectGallery, StatusNote } from "@/components/ProjectParts";

export default function LaRomana() {
  const { t } = useLang();
  const p = t.projects.laRomana;
  return (
    <>
      <PageHero eyebrow={p.place} lines={[p.name]} intro={p.intro} image={IMG.drafting} imageAlt={t.gallery.captions.drafting} corner="bl" accent="var(--coral)">
        <div className="mt-8"><BackLink /></div>
      </PageHero>
      <Objectives items={p.objectives} />
      <section className="py-20 sm:py-28" data-testid="la-romana-specialists">
        <div className="wrap grid gap-12 lg:grid-cols-12 items-center">
          <FadeUp className="lg:col-span-5">
            <div className="aspect-square overflow-hidden petal-tr bg-[var(--green-pale)] max-w-md">
              <img src={IMG.childBed} alt={t.gallery.captions.childBed} loading="lazy" className="photo w-full h-full object-cover" />
            </div>
          </FadeUp>
          <FadeUp delay={0.1} className="lg:col-span-7">
            <h2 className="text-4xl sm:text-5xl leading-tight">{p.specialistsTitle}</h2>
            <p className="mt-6 text-lg leading-relaxed text-[var(--ink-soft)]">{p.specialistsText}</p>
            <ul className="mt-8 grid grid-cols-2 sm:grid-cols-3 gap-3">
              {p.specialists.map((s, i) => (
                <li key={s} className={`px-5 py-4 font-semibold ${["bg-[var(--green-pale)]", "bg-[var(--yellow-pale)]", "bg-[var(--blue-pale)]", "bg-[var(--coral-pale)]"][i % 4]} rounded-[1.2rem_1.2rem_1.2rem_0.3rem]`} data-testid={`specialty-${i}`}>{s}</li>
              ))}
            </ul>
          </FadeUp>
        </div>
      </section>
      <StatusNote />
      <ProjectGallery keys={["drafting", "kidsBanner", "doctors", "staff", "teamShirts", "volunteerChild", "selfie", "baby"]} />
      <SupportCta title={t.common.supportProject} text={t.common.supportProjectText} />
    </>
  );
}
